module.exports = __webpack_public_path__ + "6b9abbc289b906808c24992525bd8469.svg";